import {
  UserFull,
  UserStatus,
  CompanyUser,
  UserInvitation,
  CompanyRole,
} from '@/models/users'

export interface UserState {
  me: UserFull
  filter: UserStatus
  list: CompanyUser[]
  invitations: UserInvitation[]
  roles: CompanyRole[]
}

// Store module

export const state: UserState = {
  me: {
    id: 0,
    email: '',
    language: 'ru',
    script: undefined,
    status: 0,
    roles: {},
    contacts: {
      fname: '',
      lname: '',
      phone: null,
      country: null,
      city: null,
      region: null,
      postcode: null,
      address: null,
    },
  },
  filter: UserStatus.Active,
  list: [],
  invitations: [],
  roles: [],
}
